import { useCallback } from 'react';
import useTypeFieldsConfig from '../useTypeFieldsConfig';
/**
 * Vraci identy extraktovane ze vstupu.
 *
 * @param {Object | 'codeList' | 'entity'} [fieldsConfig]
 * @param {string} [fieldsConfig.identField='code']
 * @param {string} [fieldsConfig.labelField='label']
 *
 * @returns {function} `(items: string | Object | Array<string | Object>) => string | Array<string>`
 */

export default function useEnsureIdentHandler(fieldsConfig) {
  var _useTypeFieldsConfig = useTypeFieldsConfig(fieldsConfig),
      identField = _useTypeFieldsConfig.identField;
  /**
   * @param {string | Object | Array<string | Object>} items
   */


  return useCallback(function (items) {
    var convert = function convert(c) {
      return typeof c === 'string' ? c : c[identField];
    };

    if (Array.isArray(items)) return items.map(convert);
    return items ? convert(items) : null;
  }, [identField]);
}